import {
  useGlobalComponentForAttribute,
  useModelAndAttributeFromPath
} from '@rhino-project/core/hooks';
import { RhinoResourceSpecifier } from '@rhino-project/core';
import { CellInteger, CellIntegerProps } from '../../table/cells/CellInteger';

export const ModelCellIntegerBase = ({
  formatOptions,
  ...props
}: CellIntegerProps) => {
  const { attribute } = useModelAndAttributeFromPath(
    props.model as RhinoResourceSpecifier,
    props.path as string
  );

  return (
    <CellInteger
      {...props}
      formatOptions={{
        useGrouping: ['year', 'select'].includes(attribute?.format ?? '')
          ? false
          : undefined,
        ...formatOptions
      }}
    />
  );
};

export const ModelCellInteger = (props: CellIntegerProps) =>
  useGlobalComponentForAttribute(
    'ModelCellInteger',
    ModelCellIntegerBase,
    props
  );
